import React, { useState, useEffect } from "react";
import { loginWithGoogle } from "../utility/Auth";
import { MdClose } from "react-icons/md";
import { FcGoogle } from "react-icons/fc";
import { useNavigate, useLocation, Link } from "react-router-dom";
import GlowCanvasLogo from "../components/GlowCanvasLogo";

const errorStyle = {
  color: "#DD3E3E",
  marginTop: 20,
  marginBottom: -4,
  fontSize: "1.08rem",
  textAlign: "center",
  fontWeight: 500,
  letterSpacing: "-0.3px",
};

export default function LoginDialog({ open, onClose }) {
  const [loadingGoogle, setLoadingGoogle] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  // Close dialog on route change (e.g. back navigation)
  useEffect(() => {
    if (open) {
      onClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  if (!open) return null;

  const handleGoogle = async () => {
    setError("");
    setLoadingGoogle(true);
    try {
      await loginWithGoogle();
      onClose();
    } catch (err) {
      setError("Google login failed. Please try again.");
    }
    setLoadingGoogle(false);
  };


  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(20, 24, 31, 0.22)",
        backdropFilter: "blur(1.5px)",
        zIndex: 1110,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "background 0.2s",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "linear-gradient(115deg, #fff 90%, #ffe8cc 100%)",
          borderRadius: 22,
          maxWidth: 400,
          width: "96vw",
          boxShadow: "0 8px 38px 0 rgba(85,90,100,0.18)",
          padding: "45px 34px 32px",
          position: "relative",
          transition: "box-shadow 0.15s",
        }}
        onClick={(e) => e.stopPropagation()}
      >
      

        {/* Top right: close button */}
        <button
          aria-label="Close"
          onClick={onClose}
          style={{
            position: "absolute",
            top: 17,
            right: 17,
            background: "none",
            border: "none",
            fontSize: "1.7rem",
            color: "#B2B2B2",
            cursor: "pointer",
            transition: "color 0.2s",
          }}
        >
          <MdClose />
        </button>

        {/* Logo */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 16,
          }}
        >
         <GlowCanvasLogo style={{ marginBottom: 16, userSelect: "none" }} />
        </div>

        <h2
          style={{
            fontWeight: 600,
            fontSize: "1.65rem",
            textAlign: "center",
            marginBottom: 35,
            letterSpacing: "-0.5px",
            color: "#262828",
          }}
        >
          Login or Sign Up
        </h2>

        {/* Google login button */}
        <button
          onClick={handleGoogle}
          disabled={loadingGoogle}
          style={{
            width: "100%",
            background: "#F4F5F9",
            border: "none",
            color: "#222",
            fontWeight: 600,
            fontSize: "1.15rem",
            padding: "16px 0",
            borderRadius: 15,
            boxShadow: "0 2px 14px 0 rgba(175,175,182,0.09)",
            marginBottom: 18,
            marginTop: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 17,
            cursor: loadingGoogle ? "wait" : "pointer",
            transition: "background 0.18s, box-shadow 0.18s",
          }}
        >
          <FcGoogle size={31} />
          {loadingGoogle ? "Signing in..." : "Continue with Google"}
        </button>

        {error && <div style={errorStyle}>{error}</div>}

        {/* Optional: legal text or privacy notice */}
        <div
          style={{
            textAlign: "center",
            fontSize: "0.97rem",
            color: "#ABABAB",
            marginTop: 28,
            lineHeight: 1.44,
          }}
        >
          By continuing, you agree to our
          <br />
          <Link to="/terms" style={{ color: "#FF822C", textDecoration: "underline" }}>
            Terms of Service
          </Link>{" "}
          &nbsp;and&nbsp;
          <Link to="/privacy" style={{ color: "#FF822C", textDecoration: "underline" }}>
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
}
